/**
 * NowDateTime event keys.
 *
 *
 * This event is for usage for components that need to make use of the 'now' date and time.
 * Components using this will by default use the real date and time, but can be altered
 * during testing for point in time situations. This event gives the component the ability to
 * update after the 'now' has been altered during testing.
 *
 * If 'now' is updated, the component listening to this event will be re-rendered thereby getting
 * a new 'now' date and time.
 */

const NowDateTimeEvents = {
    /*
     * Sets the now time entered by the user.
     *
     * @payload Datetime newStartTime
     */
    setNow: "NowDateTime.setNow",
};
export default NowDateTimeEvents;